import React from 'react';

import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import background from 'assets/images/riders/rider-background.png';

import OrderDetails from './containers/OrderDetails';
import ValidateOrder from './containers/ValidateOrder';
import OTPValidation from './containers/OTPValidation';
import DeliveredOrder from './containers/DeliveredOrder';

function Routes() {
  document.body.className = 'overflow-hidden';

  const history = useHistory();
  const parentMatch = useRouteMatch();
  const match = useRouteMatch(`${parentMatch.path}/:module_code`);
  const { module_code = null } = match?.params || {};
  React.useEffect(() => {
    if (!module_code) {
      history.push('/r/delivery');
    }
    return () => document.body.removeAttribute('class');
  }, [history, module_code]);

  return (
    <div
      className="flex h-full bg-no-repeat bg-bottom bg-contain"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <div className="container lg:px-0 mx-auto w-full md:max-w-xl">
        <Switch>
          <Route
            path={`${parentMatch?.path}/delivered_order`}
            component={DeliveredOrder}
          />
          <Route
            path={`${parentMatch?.path}/order_details/:order_number/:otp`}
            component={OrderDetails}
          />
          <Route path={`${parentMatch?.path}/otp`} component={OTPValidation} />
          <Route
            path={`${parentMatch?.path}/delivery/:order_number?`}
            component={ValidateOrder}
          />
        </Switch>
        {/* <Redirect to={`${parentMatch?.path}/delivery`} /> */}
      </div>
    </div>
  );
}
Routes.defaultProps = {};

Routes.propTypes = {};

export default Routes;
